import router from "@/router";
import axios from "@/axios";
import Vue from 'vue';
import {isPwa,isAndroidApp, isIosApp} from "@/utils/Pwa";
import {consumePostLoginRedirect} from "@/utils/safePath";
import {trackLogin} from "@/utils/ConversionAnalytics";

const state = {
  isAuthorized: false,
  loginError: '',
  loginInfo: '',
  token: '',
  entity: {
    uuid: '',
  },
  user: {
    id: '',
    card_number: '',
    client_type: '',
    name: '',
    surname: '',
    company: '',
    nip: '',
    address: '',
    postcode: '',
    city: '',
    phone: '',
    email: '',
    saldo: '',
    birthday: '',
    sex: '',
    self_registered: false,
    missing_fields: [],
    missing_agreements: [],
    unread_messages: 0,
    set_password: false,
  },
  agreements: [],
  userVersion: '',
};

const actions = {
  setForgotPasswordForm() {
    router.push({ name: 'ForgotPassword' })
  },
  setSignInForm() {
    router.push({ name: 'SignIn' })
  },
  setSelectForm() {
    router.push({ name: 'Login' })
  },
  setSignUpForm() {
    router.push({ name: 'SignUp' })
  },
  setSetPasswordForm() {
    router.push({ name: 'SetPassword' })
  },
  login({commit, dispatch, rootState}, payload) {
    let credentials = payload;

    credentials = {
      ...credentials,
      entity: rootState.auth.entity.uuid,
      pwa: isPwa,
      android: isAndroidApp,
      ios: isIosApp
    }

    axios.post('login', credentials)
      .then((r) => {
        if (r.data.success) {
          trackLogin('password');
          dispatch('afterLoginSuccess', {
            token: r.data.token,
            user: r.data.user,
            entity: credentials.entity,
          })
        } else {
          commit('LOGIN_ERROR', r.data.message)
        }
      });
  },
  afterLoginSuccess({commit, dispatch}, data) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
    dispatch('fetchSettings', data.entity).then(() => {
      commit('LOGIN', {
        user: data.user,
        token: data.token,
        entity: data.entity,
      });

      dispatch('fetchAccountItems')
      dispatch('fetchNavigation').then(() => {
        const postLogin = consumePostLoginRedirect();
        if (postLogin) {
          router.push(postLogin).catch(() => {});
        } else {
          dispatch('pushToFirstPage');
        }
      });
      dispatch('fetchAgreements');
      dispatch('fetchRewards');
      dispatch('clearDismissedAlerts')
    });
  },
  logout({commit, dispatch}, payload = {}) {
    dispatch('resetDates', 'points');
    dispatch('resetDates', 'messages');
    commit('LOGOUT', payload);
  },
  setUser({commit}, user) {
    return new Promise((resolve) => {
      commit('SET_USER', user)
      resolve();
    })
  },
  setLoginInfo({commit}, message) {
    commit('SET_LOGIN_INFO', message)
  },
  setLoginError({commit}, message) {
    commit('LOGIN_ERROR', message)
  },
  setAgreements({commit}, agreements) {
    commit('SET_AGREEMENTS', agreements)
  },
  clearLoginError({commit}) {
    commit('CLEAR_LOGIN_ERROR')
  },
  clearLoginInfo({commit}) {
    commit('CLEAR_LOGIN_INFO')
  },
  fetchUser({commit}) {
    return axios.get('user')
      .then((r) => {
        if (r.data.success) {
          commit('SET_USER', r.data.user)
        }
      })
  },
  fetchAgreements({commit}) {
    return axios.get('agreements')
      .then((r) => {
        if (r.data.success) {
          commit('SET_AGREEMENTS', r.data.agreements)
        }
      })
  },
  setEntityUuid({commit}, uuid) {
    commit('SET_ENTITY_UUID', uuid)
  },
  resetDates({commit}, key) {
    commit('RESET_DATES', key);
  },
  setUserVersion({commit}, version) {
    commit('SET_USER_VERSION', version)
  },
};

const mutations = {
  LOGIN(state, payload) {
    state.isAuthorized = true;
    Vue.set(state, 'user', payload.user);
    state.token = payload.token;
    state.loginError = '';
    state.loginInfo = '';
    state.entity.uuid = payload.entity;
  },
  LOGIN_ERROR(state, message) {
    state.loginError = message;
  },
  SET_LOGIN_ERROR(state, message) {
    state.loginError = message;
  },
  SET_LOGIN_INFO(state, message) {
    state.loginInfo = message;
  },
  LOGOUT(state, payload) {
    if (!payload.hasOwnProperty('errorMessage')) {
      payload.errorMessage = '';
    }

    if (!payload.hasOwnProperty('pushToLogin')) {
      payload.pushToLogin = true;
    }

    state.isAuthorized = false;
    state.token = '';
    state.loginError = payload.errorMessage;

    Vue.set(state, 'agreements', []);
    axios.defaults.headers.common['Authorization'] = null;

    if (payload.pushToLogin) {
      router.push({name: 'Login'});
    }
  },
  SET_ENTITY_UUID(state, uuid) {
    state.entity.uuid = uuid;
  },
  SET_USER(state, user) {
    Vue.set(state, 'user', user)
  },
  SET_AGREEMENTS(state, agreements) {
    Vue.set(state, 'agreements', agreements)
  },
  CLEAR_LOGIN_ERROR(state) {
    state.loginError = ''
  },
  CLEAR_LOGIN_INFO(state) {
    state.loginInfo = ''
  },
  SET_USER_VERSION(state, version) {
    state.userVersion = version;
  },
};

export default {
  state,
  actions,
  mutations
}
